export enum Tab {
  Insights = "insights",
  Feed = "feed",
}
